export const environment = {
  production: false,
  apiUrl: 'https://test.drsubodhbhade.com/api',
};
